<template>
  <qx-card-form title="成本信息" v-show="showComponent" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="isUseCarOilCost">
        <qx-tips content="如果选择“是”，本车辆开单的时候，订单的油量将采用车辆的油耗来计算，否则采用线路里的油耗计算" />
      </span>
      <div slot="loadFullOilCost" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.loadFullOilCost" placeholder="请输入载重油耗">
          <span slot="suffix" class="inputSlotText">升/百公里</span>
        </el-input>
      </div>
      <div slot="loadEmptyOilCost" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.loadEmptyOilCost" placeholder="请输入空载油耗">
          <span slot="suffix" class="inputSlotText">升/百公里</span>
        </el-input>
      </div>

      <span slot="vehicleOwnerShip">
        <qx-tips content="顺丰共建车队必须选择一个司机性质" />
      </span>
      <section slot="vehiclelineRels">
        <el-select
          style="width: 240px"
          v-model="otherFormData.vehiclelineRels"
          value-key="lineId"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
        >
          <el-option
            v-for="item in options4"
            :key="item.lineId"
            :label="item.lineCodeRule"
            :value="item"
          ></el-option>
        </el-select>
      </section>

      <span slot="purchaseDate">
        <qx-tips content="请填写车辆购买的日期，系统将从该日期开始计算车辆的折旧费" />
      </span>
      <div slot="price" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.price" placeholder="请输入购车价格">
          <span slot="suffix" class="inputSlotText">元</span>
        </el-input>
      </div>
      <div slot="residual" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.residual" placeholder="请输入残值">
          <span slot="suffix" class="inputSlotText">元</span>
        </el-input>
      </div>
      <div slot="depreciatedMonth" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.depreciatedMonth" placeholder="请输入折旧月数">
          <span slot="suffix" class="inputSlotText">月</span>
        </el-input>
      </div>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import {
  getCustomerLineByLineCode,
} from 'api/car';
export default {
  data () {
    return {
      showComponent: true,
      options4: [],
      otherFormData: {
        vehiclelineRels: [],
      },
      baseForm: {
        // 车辆性质
        vehicleOwnerShipOptions: [],
        inline: true,
        form: [
          {
            label: '车辆性质',
            value: 'vehicleOwnerShip',
            type: 'select',
            default: '',
            hide: false,
          },
          // {
          //   label: '线路绑定',
          //   value: 'vehiclelineRels',
          //   slot: true,
          //   hide: false,
          // },

          {
            label: '使用车辆油耗',
            value: 'isUseCarOilCost',
            type: 'select',
            placeholder: '请选择是否使用车辆油耗',
            options: [{
              label: '是', value: '1',
            }, {
              label: '否', value: '0',
            }],
          }, {
            label: '载重油耗',
            value: 'loadFullOilCost',
            type: 'input',
            slot: true,
          }, {
            label: '空载油耗',
            value: 'loadEmptyOilCost',
            type: 'input',
            slot: true,
          },

          {
            label: '购买时间',
            value: 'purchaseDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '购车价格',
            value: 'price',
            type: 'select',
            slot: true,
          },
          {
            label: '残值',
            value: 'residual',
            type: 'select',
            slot: true,
          },
          {
            label: '折旧月数',
            value: 'depreciatedMonth',
            type: 'input',
            slot: true,
          },
        ],
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (vehicleOwnerShipOptions) {
      this.baseForm.vehicleOwnerShipOptions = vehicleOwnerShipOptions;
    },
    async remoteMethod (query) {
      if (query !== '') {

        const aLineCodes = await getCustomerLineByLineCode({
          page: 1,
          rows: 10,
          lineCode: query,
        });

        const resResult = aLineCodes.items;
        this.options4 = resResult.filter((item) => item.lineCodeRule.toLowerCase()
          .indexOf(query.toLowerCase()) > -1);

      } else {
        this.options4 = [];
      }
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          vehicleOwnerShip: formData.vehicleOwnerShip,
          vehiclelineRels: this.otherFormData.vehiclelineRels,
          vehicleLineRels: this.otherFormData.vehiclelineRels,

          purchaseDate: this.formatDate(formData.purchaseDate),
          price: formData.price,
          residual: formData.residual,
          depreciatedMonth: formData.depreciatedMonth,
          isUseCarOilCost: formData.isUseCarOilCost,
          loadFullOilCost: formData.loadFullOilCost,
          loadEmptyOilCost: formData.loadEmptyOilCost,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.vehicleLineRelsArray = JSON.stringify(this.otherFormData.vehiclelineRels);
        formData.vehicleLineRels = JSON.stringify(this.otherFormData.vehiclelineRels);
        // console.log('成本信息提交参数', formData);
        delete formData.vehiclelineRels;
      }
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.resetBaseForm();
      if (data.vehicleOwnerShip !== undefined) {
        data.vehicleOwnerShip = String(data.vehicleOwnerShip || -1);
      }
      this.options4 = data.vehiclelineRels;

      if (data.isUseCarOilCost !== undefined && data.isUseCarOilCost !== null) {
        data.isUseCarOilCost = String(data.isUseCarOilCost);
      } else {
        // 新建状态，【是否使用车辆油耗】默认选中否
        data.isUseCarOilCost = '0';
      }

      this.$refs.baseForm.setVal(data);
      this.setFormValFromData(this.otherFormData, data);
    },
    // 修改车辆种类为【临时外调车时】
    changeToOutward () {
      // 切换成临时外调车
      this.showComponent = false;
    },
    resetToNormal () {
      // 恢复成正常模式
      this.showComponent = true;
    },
    resetBaseForm () {
      let showComponent = true;
      if (this.$route.query.type === 'outward') {
        showComponent = false;
      }
      this.showComponent = showComponent;
    },
    formChange (vehicleInfo) {
      this.resetBaseForm();
      if (this.$route.query.type === 'my') {
        if (vehicleInfo) {
          if (!this.$route.query.id) {
            this.showComponent = false;
          }
        } else {
          this.showComponent = true;
        }
      }
    },
    receivedData (vehicleInfo) {
      this.formChange(vehicleInfo);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
